import React from "react";
import Chip from "@material-ui/core/Chip";
import {Badge} from "@material-ui/core";
import intl from 'react-intl-universal';


class SeriesVideoTag extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			tagColor: '#000',
			tagTextColor: '#fff'
		};
		switch (this.props.type) {
			case "leetCode":
				this.state.tagColor = '#000';
				this.state.tagTextColor = '#fff';
				break;
			case "lintCode":
				this.state.tagColor = '#000';
				this.state.tagTextColor = '#fff';
				break;
			//难度
			case "difficult":
				// alert(this.props.title)
				this.state.tagTextColor = '#fff';
				switch (this.props.title) {
					case "难":
						this.state.tagColor = '#ff2523';
						break;
					case "中":
						this.state.tagColor = '#E7D143';
						break;
					case "易":
						this.state.tagColor = '#23e728';
						break;
					default:
						this.state.tagColor = '#E7D143';
						break;
				}
				break;
			//免费
			case "free":
				this.state.tagColor = '#16D1BC';
				this.state.tagTextColor = '#000';
				break;
			//热度
			case "hot":
				this.state.tagColor = '#ED590E';
				this.state.tagTextColor = '#000';
				break;
			//算法分类
			case "algoType":
				this.state.tagColor = '#04446C';
				this.state.tagTextColor = '#fff';
				break;

			default:
				this.state.tagColor = '#000';
				this.state.tagTextColor = '#fff';
				break;
		}
	}

	render() {
		return (
			<Chip
				label={this.props.text}
				style={{
					color: `${this.state.tagTextColor}`,
					backgroundColor: `${this.state.tagColor}`,
					marginRight: '6px',
				}}
				size="small"
			/>
		)
	}
}

class SeriesVideoTags extends React.Component {

	constructor(props, context) {
		super(props, context);

	}

	render() {
		const tags = this.props.data.map(data => {
			return <SeriesVideoTag
				text={data.tagText}
				type={data.tagType}
			/>
		});
		return (
			<div>
				{tags}
			</div>
		);
	}

}

export default SeriesVideoTags